<template>
  <div>
    <va-modal
      v-model="showModal"
      :no-outside-dismiss="true"
      id="contactNotAssociatedModal"
      ref="contactNotAssociatedModal"
      :cancelText="$t('modals.buttons.back')"
      :showOkay="false"
      :show-cancel="!validatedSuccessfully"
      size="medium"
      @cancel="handleCancel"
      :fixed-layout="true">

      <div slot="header" class="text-center mb-0">

        <h3 style="color: black; font-weight: bolder"> {{ $t('ranu.records.search_external_patient') }} </h3>
        <div class="mt-4">
          <div class="row d-inline">
            <i class="fa fa-warning" style="color: darkred; font-size: 24px"/> &nbsp;
            <span
              style="color: #6E6E6E; font-weight: bold; font-size: 24px"> {{
                $t('ranu.records.contact_not_associated')
              }}</span>
          </div>
        </div>
        <div class="text-center">
          <span
            style="color: #6E6E6E; font-weight: bold; font-size: 24px"> {{
              $t('ranu.records.follow_instructions')
            }}</span>
        </div>
      </div>

      <form class="evollu-form">
        <div class="text-center">
          <span class="is-bold"
                style="color: black; font-size: 18px"> {{ $t('ranu.records.fill_fields_parent') }}</span>
        </div>

        <div class="ml-5 mr-5">
          <h6 class="mt-3 evollu-color is-bold">{{ $t('ranu.records.first_name') }}</h6>
          <div class="row">
            <va-input
              class="mr-5"
              id=first-name-input
              :placeholder="$t('ranu.records.first_name')"
              v-model="form.data.first_name"
              :maxlength="255"
              @input="form.errors.clear('first_name');form.errors.clear('mother_name');"
              :error="form.errors.has('first_name')||form.errors.has('mother_name')"
              :error-messages="[$t(form.errors.get('first_name'))||$t(form.errors.get('mother_name'))]"
            />
          </div>
        </div>

        <div class="ml-5 mr-5">
          <h6 class="mt-3 evollu-color is-bold">{{ $t('ranu.records.last_name') }}</h6>
          <div class="row">
            <va-input
              class="mr-5"
              id=last-name-input
              :placeholder="$t('ranu.records.last_name')"
              v-model="form.data.last_name"
              :maxlength="255"
              @input="form.errors.clear('last_name');form.errors.clear('mother_name');"
              :error="form.errors.has('last_name')||form.errors.has('mother_name')"
              :error-messages="[$t(form.errors.get('last_name'))||$t(form.errors.get('mother_name'))]"
            />
          </div>
        </div>

        <div class="text-center mt-4" v-if="!validatedSuccessfully">
          <va-button
            v-if="!isLoading"
            class="validate-btn" @click.prevent="handleValidation"><span
            class="pl-3 pr-3">{{ $t('ranu.records.validate') }}</span>
          </va-button>
          <LoadingAnimation
            v-else
            :size="'5px'"
            class="d-flex justify-content-center pt-4 pb-4"/>
        </div>
        <div class="text-center" v-else>
          <div class="mt-4 mb-4">
            <div class="row d-inline">
              <i class="fa fa-check-circle evollu-color"/>
              &nbsp;
              <span class="evollu-color is-bold">{{ $t('ranu.records.data_validated_successfully') }}</span>
            </div>
            <div class="mt-3">
              <span class="is-bold" style="font-size: 18px"> {{ $t('ranu.records.proceed_validation') }}</span>
            </div>
            <va-button
              class="mt-4" @click.prevent="handleSendValidationCode"><span
              class="is-bold">{{ $t('ranu.records.send_validation_code') }}</span>
            </va-button>
          </div>
          <div>
            <span>{{ $t('ranu.records.validation_code_will_be_sent') }}</span>
          </div>
        </div>

      </form>
    </va-modal>

    <CodeSentModal
      v-if="showCodeSentModal"
      :access_code="form.accessCode"
      @canceled="handleCodeSentModalCanceled"
      @consult="handleConsult"/>
  </div>

</template>

<script>
import Errors from '@/utils/StandardErrors'
import CodeSentModal from '@/components/ranu/records/external-patient-modals/CodeSentModal'
import { AuthenticationService } from '@/api/RanuService'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

const errorsPrefix = 'ranu.records.errors.'

export default {
  components: { LoadingAnimation, CodeSentModal },
  props: {
    associate_new_contact: {
      type: Boolean,
      required: true,
    },
    process_id: {
      type: String,
      required: true,
    },
    birthdate: {
      type: String,
      required: true,
    },
    contact: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      showModal: false,
      showCodeSentModal: false,
      isLoading: false,
      form: {
        accessCode: null,
        data: {
          birthdate: this.birthdate,
          contact: this.contact,
          first_name: null,
          last_name: null,
          process_id: this.process_id,
          associate_new_contact: this.associate_new_contact
        },
        errors: new Errors()
      },
      validatedSuccessfully: false
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handleCancel: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('canceled')
      }, 250)
    },
    handleValidation: function () {
      this.isLoading = true
      AuthenticationService.addAccessAuthorization(this.form.data)
        .then((response) => {
          if (response.data) {
            this.validatedSuccessfully = true
            this.form.accessCode = response.data
          }
        })
        .catch(errors => {
          this.form.errors.record(errors.response.data.errors, errorsPrefix)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleSendValidationCode: function () {
      this.showModal = false
      this.showCodeSentModal = true
    },
    handleCodeSentModalCanceled: function () {
      this.showModal = true
      this.validatedSuccessfully = false
      this.showCodeSentModal = false
    },
    handleConsult: function (record) {
      this.showCodeSentModal = false
      this.showModal = false
      setTimeout(() => {
        this.$emit('consult', record)
      }, 250)
    }

  }
}
</script>

<style lang="scss">

.custom-box {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 60px;
  border: 4px solid #E8E8E8;
  border-top-color: #29C4AA;
}

.clickable_label {
  color: #29C4AA;
}

.evollu-color {
  color: #29C4AA;
}

.validate-btn {
  line-height: 0;
  margin-top: 0;
}

.row-validation {
  margin-top: 20px;
  margin-left: 70px;
  margin-right: 100px;
}

</style>
